// ニュースデータの型定義
export interface NewsItem {
  id: number;
  releaseDate: string;
  tag: string;
  title: string;
  url: string;
  displayType: 'normal' | 'fixed';
}

// モックデータを定義
const mockNewsData: NewsItem[] = [
  {
    id: 1,
    releaseDate: '2025年1月30日',
    tag: 'PR',
    title: '2025年3月1日 〇〇〇〇オープンします',
    url: 'https://example.com',
    displayType: 'normal', // '通常' を 'normal' に修正
  },
  {
    id: 2,
    releaseDate: '2025年1月30日',
    tag: '重要',
    title: '新型コロナウィルスに関する対応状況',
    url: 'https://example.com',
    displayType: 'fixed', // 'トップ固定' を 'fixed' に修正
  },
  {
    id: 3,
    releaseDate: '2025年1月30日',
    tag: 'お知らせ',
    title: '〇〇〇〇オープンのお知らせ',
    url: 'https://example.com',
    displayType: 'normal', // '通常' を 'normal' に修正
  },
];

// ニュースリストを取得するモック関数
export const fetchNews = async (): Promise<NewsItem[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockNewsData);
    }, 500); // 擬似的に遅延を加える（500ミリ秒）
  });
};
